import { CheckCircle2, CircleAlert, CircleDot, Loader2 } from 'lucide-react';

import type { RefreshStatus } from '../api/types.js';
import { cn } from '../lib/cn.js';

interface DriftBadgeProps {
  readonly status: RefreshStatus;
  readonly lastIndexedAt: string | null;
}

const LABELS: Record<RefreshStatus, string> = {
  ok: 'fresh',
  pending: 'indexing',
  error: 'failed',
  never: 'never indexed',
};

const STYLES: Record<RefreshStatus, string> = {
  ok: 'border-emerald-500/30 bg-emerald-500/15 text-emerald-300',
  pending: 'border-amber-500/30 bg-amber-500/15 text-amber-300',
  error: 'border-rose-500/30 bg-rose-500/15 text-rose-300',
  never: 'border-border-default bg-elevated text-text-muted',
};

const ICONS: Record<RefreshStatus, JSX.Element> = {
  ok: <CheckCircle2 className="h-3 w-3" />,
  pending: <Loader2 className="h-3 w-3 animate-spin" />,
  error: <CircleAlert className="h-3 w-3" />,
  never: <CircleDot className="h-3 w-3" />,
};

export function DriftBadge({ status, lastIndexedAt }: DriftBadgeProps): JSX.Element {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-medium',
        STYLES[status],
      )}
      title={lastIndexedAt ? `Last indexed: ${lastIndexedAt}` : 'Never indexed'}
    >
      {ICONS[status]}
      {LABELS[status]}
    </span>
  );
}
